import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { createAppQueryClient } from './lib/queryClient';
import { installGlobalErrorHandlers } from './lib/errors/globalHandlers';
import { ErrorBoundary } from './components/ErrorBoundary';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { I18nextProvider } from 'react-i18next';
import { SnackbarProvider } from 'notistack';

import { App } from './App';
import { theme } from './lib/theme';
import { TenantProvider } from './lib/tenant';
import { AuthProvider } from './lib/auth';
import { i18n } from './i18n';
import './main.css';

// SW-128 bloque 3: QueryClient con error handling centralizado (401 → window event
// 'auth:expired', reporter para todos los errors, retry policy 4xx-no / 5xx-2x).
const queryClient = createAppQueryClient();

// Global handlers para errores no-handled (window.error + unhandledrejection) — los
// rutea al reporter del bloque 3 (batch + dedup, manda al backend en buckets).
installGlobalErrorHandlers();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <I18nextProvider i18n={i18n}>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <SnackbarProvider
            maxSnack={3}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
          >
            {/* ErrorBoundary fuera de BrowserRouter — si un componente crashea, el
                fallback se muestra sin que la navegación esté en estado raro. */}
            <ErrorBoundary>
              <BrowserRouter>
                <TenantProvider>
                  <AuthProvider>
                    <App />
                  </AuthProvider>
                </TenantProvider>
              </BrowserRouter>
            </ErrorBoundary>
          </SnackbarProvider>
        </ThemeProvider>
      </QueryClientProvider>
    </I18nextProvider>
  </React.StrictMode>,
);
